module.exports = __webpack_public_path__ + "img/video.762c2b28.svg";